import { render } from "./storageActivity.vue?vue&type=template&id=56580ac7"
import script from "./storageActivity.vue?vue&type=script&lang=js"
export * from "./storageActivity.vue?vue&type=script&lang=js"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__